import { useState, createContext, useContext } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAdminMeQuery } from "@/lib/queries";

const AuthContext = createContext({
  admin: null,
  ready: false,
  login: async () => {},
  logout: () => {},
});

export function AuthProvider({ children }) {
  const qc = useQueryClient();
  const [hasToken, setHasToken] = useState(() => !!localStorage.getItem("demj_token"));
  const { data: admin, isFetched } = useAdminMeQuery(hasToken);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("demj_token", data.access_token);
    setHasToken(true);
    const { data: me } = await api.get("/auth/me");
    qc.setQueryData(["admin-me"], me);
    return me;
  };

  const logout = () => {
    localStorage.removeItem("demj_token");
    setHasToken(false);
    qc.setQueryData(["admin-me"], null);
  };

  const ready = !hasToken || isFetched;

  return (
    <AuthContext.Provider value={{ admin: admin || null, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
